import { Alert, AlertTitle, Box, Button, Checkbox, Dialog, DialogContent, FormControlLabel, Slide, Snackbar, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import MuiDialogHeader from '../Shared/MuiDialogHeader';
import { IsEmail } from '../Shared/IsEmail';
import InfoDialog from '../Shared/InfoDialog';
import { CreateRoleRequest, CreateUserSendSignupMailRequest, PermissionGateApiClient, RoleListDTO, UsersGateApiClient } from '../Api/ApiServerHooks';
import { useGateApi } from '../Api/useGateApi';
import LanguagePicker from '../Shared/LanguagePicker';
import { useTranslation } from 'react-i18next';

interface CreatePermissionDialogProps {
    tenantId?: number;
    isOpen: boolean;
    onClose: (newRole: RoleListDTO | undefined) => void;
}

export default function CreatePermissionDialog(props: Readonly<CreatePermissionDialogProps>) {
    const { isOpen, onClose, tenantId } = props;
    const { t } = useTranslation();
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [name, setName] = useState('');
    const [openCreateError, setOpenCreateError] = useState(false);
    const { authorizedApi } = useGateApi(PermissionGateApiClient);


    useEffect(() => {
        setName('');
        setButtonDisabled(false);
    }, [isOpen]);


    function TransitionLeft(props: any) {
        return <Slide {...props} direction='left' />;
    }

    const handleClose = (event: any) => {
        setOpenCreateError(false);
    }

    return (
        <Dialog onClose={() => onClose(undefined)} open={isOpen} sx={{ zIndex: 5002}}>
            <MuiDialogHeader showCloseText title={t('Administration.createRole')} onClose={() => onClose(undefined)} />
            <DialogContent>
                <Box>
                    <Box>
                        <TextField
                            sx={{ margin: '12px', marginLeft: '24px', width: '350px' }}
                            label={t('Users.Name')}
                            size='small'
                            variant='outlined'
                            value={name}
                            onChange={(e) => { setName(e.target.value); }} />
                    </Box>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                        <Button variant='contained' sx={{ margin: 'auto' }} disabled={name.length === 0 || buttonDisabled} onClick={() => {
                            setButtonDisabled(true);
                            authorizedApi?.createRole(new CreateRoleRequest({
                                name: name,
                                tenantId: tenantId
                            })).then((e) => {
                                if (e.role) {
                                    onClose(e.role);
                                }
                                else {
                                    setOpenCreateError(true);
                                }
                                setButtonDisabled(false);
                            });
                        }}>{t('Users.Insert')}</Button>
                    </Box>
                    <Box className="create-perm-form-popup">
                        <Snackbar
                            TransitionComponent={TransitionLeft}
                            open={openCreateError}
                            autoHideDuration={3000}
                            onClose={handleClose}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }} >
                            <Alert onClose={handleClose} severity="warning">
                                <AlertTitle>{t('Administration.ProjectCreationError')}</AlertTitle>
                            </Alert>
                        </Snackbar>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
}
